import { createReactPlayer } from 'react-player/lib/ReactPlayer';
import FilePlayer from 'react-player/lib/players/FilePlayer';

// Custom logic for ios
// react-player checks the url type by default, and returns null if the data type is base64
// since blob is not processed for some reason by ios we have to pass base64 to src in our case
// this file replaces the canPlay check
// also see getHlsPlaylist - /lib/frontend/video/hls
export const ReactPlayer = createReactPlayer([
  {
    key: 'file',
    canPlay: () => true,
    lazyPlayer: FilePlayer,
  },
]);
